import { User } from "@amsanalytics/react-shared-library";
import { CreateUserResult } from "../../Data/UserSummary";

export const LOAD_ALL_USERS = 'LOAD_ALL_USERS';
export const LOAD_ALL_USERS_SUCCESS = 'LOAD_ALL_USERS_SUCCESS';

export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';

export const CREATE_EMPLOYEE = 'CREATE_EMPLOYEE';
export const CREATE_EMPLOYEE_SUCCESS = 'CREATE_EMPLOYEE_SUCCESS';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

export const REASSIGN_EMPLOYEE_ASSIGNMENTS = "REASSIGN_EMPLOYEE_ASSIGNMENTS";
export const REASSIGN_EMPLOYEE_ASSIGNMENTS_SUCCESS = "REASSIGN_EMPLOYEE_ASSIGNMENTS_SUCCESS";

export const RESEND_USER_INVITE = 'RESEND_USER_INVITE';
export const RESEND_USER_INVITE_SUCCESS = 'RESEND_USER_INVITE_SUCCESS';

export const CLEAR_USER_MANAGEMENT_LOADING_LABEL = 'CLEAR_USER_MANAGEMENT_LOADING_LABEL';

/************************   Begin User    ******************************/

// LOAD ALL USERS
export interface LoadAllUsersAction {
  type: typeof LOAD_ALL_USERS;
  payload: { clientId: string };
}
export const loadAllUsers = (clientId: string): LoadAllUsersAction => {
  return {
    type: LOAD_ALL_USERS,
    payload: { clientId }
  };
};

export interface LoadAllUsersSuccessAction {
  type: typeof LOAD_ALL_USERS_SUCCESS;
  payload: { users: User[] };
}
export const loadAllUsersSuccess = (users: User[]): LoadAllUsersSuccessAction => {
  return {
    type: LOAD_ALL_USERS_SUCCESS,
    payload: { users }
  };
}

// CREATE
export interface CreateUserAction {
  type: typeof CREATE_USER;
  payload: { user: User };
}
export const createUser = (user: User): CreateUserAction => {
  return {
    type: CREATE_USER,
    payload: { user }
  };
}
export interface CreateUserSuccessAction {
  type: typeof CREATE_USER_SUCCESS;
  payload: { result: CreateUserResult };
}
export const createUserSuccess = (result: CreateUserResult): CreateUserSuccessAction => {
  return {
    type: CREATE_USER_SUCCESS,
    payload: { result }
  };
}

export interface CreateEmployeeAction {
  type: typeof CREATE_EMPLOYEE;
  payload: { employee: User };
}

export const createEmployee = (employee: User): CreateEmployeeAction => {
  return {
    type: CREATE_EMPLOYEE,
    payload: { employee }
  };
}

export interface CreateEmployeeSuccessAction {
  type: typeof CREATE_EMPLOYEE_SUCCESS;
  payload: { result: CreateUserResult };
}

export const createEmployeeSuccess = (result: CreateUserResult): CreateEmployeeSuccessAction => {
  return {
    type: CREATE_EMPLOYEE_SUCCESS,
    payload: { result }
  };
}

// UPDATE
export interface UpdateUserAction {
  type: typeof UPDATE_USER;
  payload: { user: User };
}
export const updateUser = (user: User): UpdateUserAction => {
  return {
    type: UPDATE_USER,
    payload: { user }
  };
}
export interface UpdateUserSuccessAction {
  type: typeof UPDATE_USER_SUCCESS;
  payload: { user: User };
}
export const updateUserSuccess = (user: User): UpdateUserSuccessAction => {
  return {
    type: UPDATE_USER_SUCCESS,
    payload: { user }
  };
}

export interface ResendUserInviteAction {
  type: typeof RESEND_USER_INVITE;
  payload: { adUserId: string, reactivateAfterResend: boolean };
}
export const resendUserInvite = (adUserId: string, reactivateAfterResend: boolean): ResendUserInviteAction => {
  return {
    type: RESEND_USER_INVITE,
    payload: { adUserId, reactivateAfterResend }
  };
}

export interface ResendUserInviteSuccessAction {
  type: typeof RESEND_USER_INVITE_SUCCESS;
  payload: { adUserId: string };
}
export const resendUserInviteSuccess = (adUserId: string): ResendUserInviteSuccessAction => {
  return {
    type: RESEND_USER_INVITE_SUCCESS,
    payload: { adUserId }
  };
}

export const REINSTATE_USER = 'REINSTATE_USER';
export interface ReinstateUserAction {
  type: typeof REINSTATE_USER;
  payload: { adUserId: string };
}
export const reinstateUser = (adUserId: string): ReinstateUserAction => ({
  type: REINSTATE_USER,
  payload: { adUserId }
});

export const REINSTATE_USER_SUCCESS = 'REINSTATE_USER_SUCCESS';
export interface ReinstateUserSuccessAction {
  type: typeof REINSTATE_USER_SUCCESS;
  payload: { adUserId: string };
}
export const reinstateUserSuccess = (adUserId: string): ReinstateUserSuccessAction => ({
  type: REINSTATE_USER_SUCCESS,
  payload: { adUserId }
});

export const SEND_APP_CENTER_LINK = 'SEND_APP_CENTER_LINK';
export interface SendAppCenterLinkAction {
  type: typeof SEND_APP_CENTER_LINK;
  payload: { adUserId: string };
}
export const sendAppCenterLink = (adUserId: string): SendAppCenterLinkAction => ({
  type: SEND_APP_CENTER_LINK,
  payload: { adUserId }
});

export const SEND_APP_CENTER_LINK_SUCCESS = 'SEND_APP_CENTER_LINK_SUCCESS';
export interface SendAppCenterLinkSuccessAction {
  type: typeof SEND_APP_CENTER_LINK_SUCCESS;
  payload: { adUserId: string };
}
export const sendAppCenterLinkSuccess = (adUserId: string): SendAppCenterLinkSuccessAction => ({
  type: SEND_APP_CENTER_LINK_SUCCESS,
  payload: { adUserId }
});

export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET';
export interface RequestPasswordResetAction {
  type: typeof REQUEST_PASSWORD_RESET;
  payload: { adUserId: string };
}
export const requestPasswordReset = (adUserId: string): RequestPasswordResetAction => ({
  type: REQUEST_PASSWORD_RESET,
  payload: { adUserId }
});

export const REQUEST_PASSWORD_RESET_SUCCESS = 'REQUEST_PASSWORD_RESET_SUCCESS';
export interface RequestPasswordResetSuccessAction {
  type: typeof REQUEST_PASSWORD_RESET_SUCCESS;
  payload: { adUserId: string };
}
export const requestPasswordResetSuccess = (adUserId: string): RequestPasswordResetSuccessAction => ({
  type: REQUEST_PASSWORD_RESET_SUCCESS,
  payload: { adUserId }
});

// Generates a guest invitation redeem link WITHOUT sending the Graph email, for an admin to copy/share manually.
export const GENERATE_INVITATION_LINK = 'GENERATE_INVITATION_LINK';
export interface GenerateInvitationLinkAction {
  type: typeof GENERATE_INVITATION_LINK;
  payload: { adUserId: string };
}
export const generateInvitationLink = (adUserId: string): GenerateInvitationLinkAction => ({
  type: GENERATE_INVITATION_LINK,
  payload: { adUserId }
});

export const GENERATE_INVITATION_LINK_SUCCESS = 'GENERATE_INVITATION_LINK_SUCCESS';
export interface GenerateInvitationLinkSuccessAction {
  type: typeof GENERATE_INVITATION_LINK_SUCCESS;
  payload: { url: string };
}
export const generateInvitationLinkSuccess = (url: string): GenerateInvitationLinkSuccessAction => ({
  type: GENERATE_INVITATION_LINK_SUCCESS,
  payload: { url }
});

// Dismisses the invitation-link dialog by clearing the resolved URL from state.
export const CLEAR_INVITATION_LINK = 'CLEAR_INVITATION_LINK';
export interface ClearInvitationLinkAction {
  type: typeof CLEAR_INVITATION_LINK;
}
export const clearInvitationLink = (): ClearInvitationLinkAction => ({
  type: CLEAR_INVITATION_LINK
});

export interface DeleteUserAction {
  type: typeof DELETE_USER;
  payload: { adUserId: string };
}
export const deleteUser = (adUserId: string): DeleteUserAction => {
  return {
    type: DELETE_USER,
    payload: { adUserId }
  };
}

export interface DeleteUserSuccessAction {
  type: typeof DELETE_USER_SUCCESS;
  payload: { adUserId: string };
}
export const deleteUserSuccess = (adUserId: string): DeleteUserSuccessAction => {
  return {
    type: DELETE_USER_SUCCESS,
    payload: { adUserId }
  };
}

export interface ReassignEmployeeAssignmentsAction {
  type: typeof REASSIGN_EMPLOYEE_ASSIGNMENTS;
  payload: { fromEmployeeId: string, toEmployeeIds: string[] };
}

export const reassignEmployeeAssignments = (fromEmployeeId: string, toEmployeeIds: string[]): ReassignEmployeeAssignmentsAction => {
  return {
    type: REASSIGN_EMPLOYEE_ASSIGNMENTS,
    payload: { fromEmployeeId, toEmployeeIds },
  };
}

export interface ReassignEmployeeAssignmentsSuccessAction {
  type: typeof REASSIGN_EMPLOYEE_ASSIGNMENTS_SUCCESS;
  payload: { fromEmployeeId: string, toEmployeeIds: string[] };
}

export const reassignEmployeeAssignmentsSuccess = (fromEmployeeId: string, toEmployeeIds: string[]): ReassignEmployeeAssignmentsSuccessAction => {
  return {
    type: REASSIGN_EMPLOYEE_ASSIGNMENTS_SUCCESS,
    payload: { fromEmployeeId, toEmployeeIds },
  };
}

export interface ClearUserManagementLoadingLabelAction {
  type: typeof CLEAR_USER_MANAGEMENT_LOADING_LABEL;
  payload: {};
}

export const clearUserManagementLoadingLabel = (): ClearUserManagementLoadingLabelAction => {
  return {
    type: CLEAR_USER_MANAGEMENT_LOADING_LABEL,
    payload: {}
  };
}

// Revoke With Reassignment (atomic)
export const REVOKE_WITH_REASSIGNMENT = 'REVOKE_WITH_REASSIGNMENT';
export interface RevokeWithReassignmentAction {
  type: typeof REVOKE_WITH_REASSIGNMENT;
  payload: { adUserId: string; fromEmployeeId: string; toEmployeeIds: string[] };
}
export const revokeWithReassignment = (adUserId: string, fromEmployeeId: string, toEmployeeIds: string[]): RevokeWithReassignmentAction => {
  return {
    type: REVOKE_WITH_REASSIGNMENT,
    payload: { adUserId, fromEmployeeId, toEmployeeIds }
  };
}

export const REVOKE_WITH_REASSIGNMENT_SUCCESS = 'REVOKE_WITH_REASSIGNMENT_SUCCESS';
export interface RevokeWithReassignmentSuccessAction {
  type: typeof REVOKE_WITH_REASSIGNMENT_SUCCESS;
  payload: { adUserId: string };
}
export const revokeWithReassignmentSuccess = (adUserId: string): RevokeWithReassignmentSuccessAction => {
  return {
    type: REVOKE_WITH_REASSIGNMENT_SUCCESS,
    payload: { adUserId }
  };
}

// ************************   End User    ******************************

export type AdminAction =
  LoadAllUsersAction
  | LoadAllUsersSuccessAction
  | CreateUserAction
  | CreateUserSuccessAction
  | CreateEmployeeAction
  | CreateEmployeeSuccessAction
  | UpdateUserAction
  | UpdateUserSuccessAction
  | ReassignEmployeeAssignmentsAction
  | ReassignEmployeeAssignmentsSuccessAction
  | ResendUserInviteAction
  | ResendUserInviteSuccessAction
  | ReinstateUserAction
  | ReinstateUserSuccessAction
  | SendAppCenterLinkAction
  | SendAppCenterLinkSuccessAction
  | RequestPasswordResetAction
  | RequestPasswordResetSuccessAction
  | GenerateInvitationLinkAction
  | GenerateInvitationLinkSuccessAction
  | ClearInvitationLinkAction
  | DeleteUserAction
  | DeleteUserSuccessAction
  | ClearUserManagementLoadingLabelAction
  | RevokeWithReassignmentAction
  | RevokeWithReassignmentSuccessAction;
